import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectPowerGate from './../../components/site/select_power_gate'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectPowerGate: state.searchFormCondition.selectPowerGate,
})

const SelectPowerGateContainer = connect(mapStateToProps, mapDispatchToProps)(SelectPowerGate)

export default SelectPowerGateContainer
